import { makeStyles } from "@material-ui/core"
import { useHistory } from "react-router-dom"
import { AfriqRedButton } from "../AfriqButton"
import { useTranslation } from "react-i18next"
import { RouteAdminUser } from "../../Admin/constant/routesName"

export function SuccessPaymentAnnounceAd() {
    const classes = styles()
    const history = useHistory()
    const { t } = useTranslation<'common'>()

    return <div className={classes.container}>
        <p className={classes.check}>✅</p>
        <p className={classes.text}>{t('label.success-paiment.paiment-reussi-annonce-ad')} 👍</p>
        <AfriqRedButton onClick={() => { 
            history.replace({
                pathname: `${RouteAdminUser.ANNOUNCES_ADS}`
            }) 
        }}>
            {t('paiement.label.voir-mes-annonces-boostesSee')}
        </AfriqRedButton>
    </div>
}

const styles = makeStyles(() => ({
    container: {
        width: '100%',
        height: '50vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        padding: '20px 0'
    },
    check: {
        fontSize: '36px',
    },
    text: {
        fontSize: '24px'
    }
}))